module.exports = __webpack_public_path__ + "media/images/shared/muevo_voice_logo-93578ed1e34dc794e9ce8515d5290295.png";